import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { setLogin } from "./userSlice";

const initialState = {
    isLoading: false,
    isResending: false,
    registerData: {},
    errorMsg: "",
    isError: false
}





export const registerWithGoogle = createAsyncThunk('registerWithGoogle', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.registerWithGoogle(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setRegister(true))
                Toastify.success("Student Registered successfully");
                localStorage.setItem("token",data.data.token)

        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const registerStudent = createAsyncThunk('registerStudent', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.registerStudent(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                // dispatch(setRegister(true))
                // Toastify.success("Student Registered successfully");
                // console.log("data reg",data.data)
                // localStorage.setItem("token",data.data.token)

        }
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const registerStudentSlice = createSlice({
    name: "register",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setRegister: (state, action) => {
            state.registerData = action.payload
        },
        
    },
    
})

export const { setLoading,setRegister, } = registerStudentSlice.actions

export default registerStudentSlice.reducer;